import Icon from '../Icon.vue'

Icon.register({
  'ics': {
    width: 20,
    height: 20,
    paths: [
      {
        d: 'M10 5h2.176L10 2.824V5zm3-2.003l2 2V9h-2V7H9a1 1 0 01-1-1V2H2v16h11v-2h2v3a1 1 0 01-1 1H1a1 1 0 01-1-1V1a1 1 0 011-1h9.003l2 2 .997.997zM9.371 15.012v-4.986h1.226v4.986H9.371zm3.963.042c-.582 0-1.023-.196-1.387-.56-.525-.526-.505-1.226-.505-1.975 0-.75-.02-1.45.505-1.976.364-.364.805-.559 1.387-.559.945 0 1.709.524 1.89 1.624h-1.246c-.078-.28-.231-.533-.637-.533-.225 0-.393.092-.484.211-.112.147-.19.322-.19 1.233 0 .91.078 1.085.19 1.232.09.12.259.21.484.21.406 0 .559-.252.637-.532h1.247c-.182 1.1-.946 1.625-1.891 1.625zm3.955 0c-.764 0-1.388-.14-1.892-.658l.785-.784c.259.258.714.35 1.114.35.483 0 .714-.162.714-.449a.416.416 0 00-.098-.294c-.063-.063-.168-.112-.33-.133l-.602-.084c-.441-.063-.777-.21-1.002-.44-.23-.239-.342-.575-.342-1.003 0-.91.686-1.575 1.82-1.575.715 0 1.254.168 1.682.594l-.771.771c-.315-.316-.728-.294-.945-.294-.428 0-.603.245-.603.462 0 .063.022.154.098.231a.57.57 0 00.344.148l.602.084c.448.062.77.203.98.413.266.26.372.63.372 1.093 0 1.014-.876 1.568-1.926 1.568z'
      }
    ]
  }
})
